export default __webpack_public_path__ + "static/media/screen5.59b743f9.png";